import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Box, Typography, Divider } from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import ProductInfo from '../ProductInfo';
import ProductInfoUnderOrder from './ProductInfoUnderOrder';


export default function ProductStatus({ productObj }) {

  return (
    <>
    {productObj.statusname==='DESIGNING' || productObj.statusname==='DESIGN PRINTING'|| productObj.statusname==='PLANNING' || productObj.statusname==='IN PRODUCTION'?
      <Grid container direction="row" sx={{ padding: 1, width: '100%', justifyContent: "flex-start", alignItems: "center", borderTop: '1px solid #d9d9d9' }}>
        <Grid lg={2} item sx={{ width: '100%' }} ><Typography variant="h5">Status Details</Typography> </Grid>
        <Grid lg={10} item sx={{ padding: 1, borderLeft: '1px solid #69c0ff', borderRight: '1px solid #69c0ff', borderRadius: 2 }}>
          <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center" }}>
            <Grid item lg={3}>
              <FieldView label="Customer Design Status" value={productObj.designstatus === '' ? 'DESIGNING' : productObj.designstatus} />
            </Grid>
            <Grid item lg={3}>
              <FieldView label="QA Design Status" value={productObj.designstatusqa === '' ? 'DESIGNING' : productObj.designstatusqa} />
            </Grid>
            <Grid item lg={3}>
              <FieldView label="RM Status" value={productObj.rmstatus === '' && productObj.statusname === 'DESIGNING' ? 'PLANNING' : productObj.rmstatus} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      :<></>}
    </>
  )
}